export default {"src":"https://static.upbound.io/_next/static/media/favicon.e3e8d185.ico","height":48,"width":48,"blurWidth":0,"blurHeight":0};